// extracted by mini-css-extract-plugin
export default {"card":"c-e_bV"};